module.exports = __webpack_public_path__ + "img/corp-new.6ea17d32.png";